import { render, staticRenderFns } from "./FollowUpContactBox.vue?vue&type=template&id=e8356ff0&scoped=true&"
import script from "./FollowUpContactBox.vue?vue&type=script&lang=js&"
export * from "./FollowUpContactBox.vue?vue&type=script&lang=js&"
import style0 from "./FollowUpContactBox.vue?vue&type=style&index=0&id=e8356ff0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8356ff0",
  null
  
)

export default component.exports